<template>
    <li>
        <div @click="viewSchema" :class="nodeClass">
            {{ schema.displayName }}
            <span
                v-if="schema.displayName.toUpperCase() !== schema.name.toUpperCase()"
                class="schema-name"
            >
                ({{ schema.name }})
            </span>
        </div>
        <ul v-if="children != null && children.length > 0">
            <schema-hierarchy-node
                v-for="childTreeEntry in children"
                :key="childTreeEntry.key"
                :schema-tree-entry="childTreeEntry"
                @viewThingSchema="viewThingSchema"
            />
        </ul>
    </li>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SchemaTreeEntry } from "@/lib/schemaUtils";

const { schemaTreeEntry } = defineProps<{
    schemaTreeEntry: SchemaTreeEntry
}>();

const emit = defineEmits<{
    (e: "viewThingSchema", thingSchemaName: string);
}>()

const schema = computed(() => schemaTreeEntry.schema);
const children = computed(() => schemaTreeEntry.children);
const nodeClass = computed(() => {
    if (schema.value.displayName.indexOf('MISSING') === 0) {
        return "node error-node";
    } else if (schemaTreeEntry.isInheritedMasterSchema) {
        return "node inherited-master-schema";
    } else {
        return "node";
    }
});

function viewSchema() {
    emit("viewThingSchema", schema.value.name);
}

function viewThingSchema(name: string) {
    emit("viewThingSchema", name);
}

</script>
<style scoped>
.error-node {
    background-color: #e50001;
    color: white;
}

.inherited-master-schema {
    background-color: #dddddd;
}

.schema-name {
    font-size: 0.7em;
    display: block;
    margin: 0;
}
</style>
